// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Ma6B","upload":"Small_upload__1fMzZ","imageWrap":"Small_imageWrap__18lij","removeBtn":"Small_removeBtn__2-gXG"};